<template>
  <div class='scoped'>
    <Header :router_url='router_url'></Header>

    <!-- 跳转到app -->
    <div class="app_tag _width">
      <img src="@/assets/image/header/logo.png"
           alt="">
      <button @click="openapp()">下载APP</button>
    </div>
    <!-- 跳转到app end-->

    <!-- conter -->
    <div class="conter_wp  mobile">
      <div class="banner_wp _width">

        <div class="conter _width">
          <!-- 居中 -->
          <!-- :class="{details.type==1 ?'typeHeight1':'',details.type==2 ?'typeHeight2':''}" -->
          <div class="wrap banner">
            <!-- 导航 -->
            <div class="href_tag _width">
              <div class="href_tag_wp _width _height">

                <div class="bread-crumbs _width">
                  当前位置：<a href="javascript:;"
                     @click="tag()">活动详情</a> &gt;
                  作品详情
                </div>

                <p class="href_title _width">{{details.opusName}}</p>
                <!-- <span class="icon">赛</span>经济日报“大美中国•小康印记”参赛作品 -->
              </div>
            </div>
            <!-- 导航 end-->

            <Loading :loading_bool="loading_bool"></Loading>

            <!-- 封面信息 -->
            <div class="cover_details _width"
                 v-if="!loading_bool && details_son">

              <!-- 单图 -->
              <div class="details_left_null "
                   v-if="details_son.length==''">
                <div class="error_img_conter">
                  <img :src="error_login"
                       class="error_login_img"
                       alt="">
                </div>
              </div>

              <div class="details_left "
                   v-else>
                <work_swiper_type1 :childData="details"
                                   @parentEvent="toClick"></work_swiper_type1>
              </div>

              <div class="details_right _height">
                <!-- <p class="right_title _width">这是标题</p> -->
                <p class="left_title _width">
                  <span class="icon">赛</span>{{details.activityName}}
                </p>
                <!-- 用户 -->
                <div class="right_user _width">
                  <!-- 进入本人 -->
                  <!-- <router-link to="/Pcenter?type=0"
                               class="header_img"
                               v-if="userid == details.authorId">
                    <img :src="details.headimg"
                         alt="">
                  </router-link> -->

                  <!-- 别人首页 -->
                  <!-- <router-link :to="'/Ucenter/'+details.authorId"
                               class="header_img"
                               v-if="userid != details.authorId">
                    <img :src="details.headimg"
                         alt="">
                  </router-link> -->

                  <a href="javascript:;"
                     @click="on_ucenter(details.authorId)"
                     class="header_img">
                    <img :src="details.headimg"
                         alt="">
                  </a>

                  <p class="name ">
                    {{details.fullname}}
                  </p>
                  <div v-if="this.isLogin_user.id != details.authorId">
                    <button class="follow_button follow"
                            @click="insertFollow_data()"
                            v-if="details.isFollow !==1">+关注</button>
                    <button class="follow_null follow"
                            @click="deleteFollow_data()"
                            v-if="details.isFollow ==1">已关注</button>
                  </div>

                </div>
                <!-- 用户 end -->

                <!-- 简介 -->
                <div class="desc_zw _width">

                  <div class="desc_conter">
                    <input type="checkbox"
                           id="showMoreOrLess">
                    <div class="desc_pp">
                      <p class="content"
                         v-if="details.description !==''">
                        {{details.description}}
                      </p>

                      <p class="content"
                         v-if="details.description ==''">
                        暂无...</p>
                    </div>
                    <label for="showMoreOrLess"
                           class="show-more gd ">
                      <span><img src="@/assets/image/works/go_show.png"
                             alt=""></span>
                    </label>
                    <label for="showMoreOrLess"
                           class="show-less gd reg">
                      <span><img src="@/assets/image/works/go_show.png"
                             alt=""></span>
                    </label>
                  </div>

                </div>
                <!-- 简介 end-->

                <!-- 设备信息 -->
                <ul class="list_txt _width ">
                  <li class="_width fl">
                    <p>拍摄时间：</p>
                    <span v-if="details.shootTime">{{details.shootTime.substring(0,10)}}</span>
                  </li>
                  <li class="_width fl">
                    <p>拍摄地点：</p>
                    <span>{{details.shootPlace}}</span>
                  </li>
                </ul>

                <!-- 单图  type==2 默认-->
                <ul class="list_txt _width "
                    v-if="on_slick ==0 && details_son_one">
                  <li class="_width fl"
                      v-if="details_son_one.width && details_son_one.height">
                    <p>尺寸：</p>
                    <span>
                      {{details_son_one.width}}&nbsp;x&nbsp;{{details_son_one.height}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="details_son_one.make">
                    <p>相机型号：</p>
                    <span>{{details_son_one.make}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="details_son_one.fnumber">
                    <p>光圈值：</p>
                    <span>{{details_son_one.fnumber}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="details_son_one.exposureTime">
                    <p>曝光时间：</p>
                    <span>{{details_son_one.exposureTime}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="details_son_one.isoSpeed">
                    <p>ISO：</p>
                    <span>{{details_son_one.isoSpeed}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="details_son_one.focalLength">
                    <p>焦距：</p>
                    <span>{{details_son_one.focalLength}}</span>
                  </li>

                </ul>

                <!-- 组图  type==2 -->
                <ul class="list_txt _width "
                    v-if="on_slick ==1 && photo_text">
                  <li class="_width fl"
                      v-if="photo_text.width && photo_text.height">
                    <p>尺寸：</p>
                    <span>{{photo_text.width}}&nbsp;x&nbsp;{{photo_text.height}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="photo_text.make">
                    <p>相机型号：</p>
                    <span>{{photo_text.make}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="photo_text.fnumber">
                    <p>光圈值：</p>
                    <span>{{photo_text.fnumber}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="photo_text.exposureTime">
                    <p>曝光时间：</p>
                    <span>{{photo_text.exposureTime}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="photo_text.isoSpeed">
                    <p>ISO：</p>
                    <span>{{photo_text.isoSpeed}}</span>
                  </li>
                  <li class="_width fl"
                      v-if="photo_text.focalLength">
                    <p>焦距：</p>
                    <span>{{photo_text.focalLength}}</span>
                  </li>

                </ul>

                <!-- 设备信息 end-->

                <!-- 分享 -->
                <ul class="list_txt _width ">
                  <li class="_width fl flex_wrap"
                      style="margin-top: 0.2rem;">
                    <p style="width:0.65rem;display: flex;">分享：</p>
                    <div class="share _width">
                      <a href="javascript:;"
                         @click="share_wb"
                         @mouseenter="shareicon = 1"
                         @mouseleave="shareicon = 0">
                        <img src="@/assets/image/share/wb1.png"
                             alt=""
                             class="icons">
                        <img src="@/assets/image/share/wb2.png"
                             alt=""
                             class="hide_tab icons"
                             :class="shareicon == 1 ?'show_icon':''">
                      </a>
                      <a href="javascript:;"
                         @click="share_qq"
                         @mouseenter="shareicon = 2"
                         @mouseleave="shareicon = 0">
                        <img src="@/assets/image/share/qq1.png"
                             alt=""
                             class="icons">
                        <img src="@/assets/image/share/qq2.png"
                             alt=""
                             class="hide_tab icons"
                             :class="shareicon == 2 ?'show_icon':''">
                      </a>
                      <a href="javascript:;"
                         @click="share_qz"
                         @mouseenter="shareicon = 3"
                         @mouseleave="shareicon = 0">
                        <img src="@/assets/image/share/kj1.png"
                             alt=""
                             class="icons">
                        <img src="@/assets/image/share/kj2.png"
                             alt=""
                             class="hide_tab icons"
                             :class="shareicon == 3 ?'show_icon':''">
                      </a>
                      <!--  -->

                      <a href="javascript:;"
                         style="overflow:inherit;margin-right:0"
                         @mouseenter="shareicon = 4"
                         @mouseleave="shareicon = 0">
                        <img src="@/assets/image/share/wx1.png"
                             alt=""
                             class="icons">
                        <img src="@/assets/image/share/wx2.png"
                             alt=""
                             class="hide_tab icons"
                             :class="shareicon == 4 ?'show_icon':''">

                        <!-- 微信code -->
                        <div class="wx_code"
                             :class="shareicon == 4 ?'show_code':''">
                          <div>
                            <div class="wecodeSp"
                                 id="qrcodes"
                                 ref="qrcodeContainers"></div>

                            <span></span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </li>
                </ul>
                <!-- 分享 end-->

                <!-- 投票数 -->
                <ul class="list_txt _width "
                    v-if="isWebVote == 1 && isEndVote ==1">
                  <li class="_width fl flex_wrap"
                      style="margin-top: 0.2rem;">
                    <p style="width:0.6rem;display: flex;">票数：</p>
                    <span class="porn_style">{{details.workVoke}}</span>
                  </li>
                </ul>
                <!-- 投票数 end-->

                <!-- 投票 -->
                <div class="vote_conter fl"
                     v-if="isWebVote ==1 && isEndVote==0">

                  <!-- 已经投票 -->
                  <div class="no"
                       v-if="details.isVote ==0  ">
                    <div class="vote fl "
                         @click="vote(details.workId,details.type)"
                         v-ripple="'rgba(255, 255, 255, 0.45)'">
                      <span>{{details.workVoke}}票</span>
                      <div class="vote_right  already-follow-wrap">
                        <button class="already-follow-icon-box">已投票</button>
                        <button class="unfollow-icon-box ">取消投票</button>
                      </div>
                    </div>
                  </div>

                  <!-- 未投票 -->
                  <div class="no"
                       v-if="details.isVote !==0  ">
                    <div class="vote fl "
                         @click="vote(details.workId,details.type)"
                         v-ripple="'rgba(255, 255, 255, 0.45)'">
                      <span>{{details.workVoke}}票</span>
                      <div class="vote_right  already-follow-wrap">
                        <button class="unfollow-icon-box "
                                style="top:0;">为Ta投票</button>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- 投票 end -->
              </div>
            </div>
            <!-- 封面信息 end-->

            <!-- 暂无数据 -->
            <div class="null_data _width"
                 v-if="!loading_bool && !details_son  ">
              <img src="@/assets/image/common/null_data.png"
                   alt="">
              <p>暂无数据...</p>
            </div>
            <!-- 暂无数据 -->

          </div>
          <!-- 居中 -->

        </div>

        <!-- <Banner></Banner> -->

        <div class="wrap ">
          <!-- 作品列表 -->
          <div class="pad _width">
            <p class="works_tt _widh">相关作品</p>

            <div class="classification_list_wrap ">

              <!-- 加载前 -->
              <Loading :loading_bool="loading_bool"></Loading>
              <!-- 加载完成 -->
              <ul class="classification_list _width"
                  id="app"
                  v-if="!loading_bool &&  works_data.records &&  works_data.records.length!==0">
                <li v-for="(item,index) in works_data.records"
                    :key="index"
                    class="fl anmition_show">
                  <div class="li_son _width fl">
                    <div class="cover_div _width fl">
                      <div class="cover_s"
                           @click="on_details(item.activityId, item.fullname, item.type, item.workId,item.authorId)">
                        <div class="error_img"
                             v-if="!works_data">
                          <div class="error_img_conter">
                            <img :src="error_login"
                                 alt="">
                          </div>
                        </div>

                        <img :src="item.opusCover|filterFun_ss"
                             :alt="item.title"
                             :onerror="defaultImg"
                             v-if="works_data"
                             class="cover_img fade_image_out">

                      </div>

                      <!-- 封面icon -->
                      <span class="img_icon"
                            v-if="item.workNum!==0">
                        {{item.workNum}}
                      </span>
                      <!-- 封面icon end -->

                      <div class="cover_img_position _width">

                        <div class="positin _width">
                          <div class="mohu2 da">
                            <!-- <img :src="item.img"
                                 alt="item.title"> -->
                          </div>
                          <div class="mohu2 xiao">
                            <!-- <img :src="item.img"
                                 alt="item.title"> -->
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="_width cover_bottom fl">
                      <router-link class="title_tag _width" :to="'/Ucenter/'+item.authorId">{{item.opusName}}</router-link>

                      <!-- 用户信息 -->
                      <div class="user _width">
                        <router-link class="left"
                                     :to="'/Ucenter/'+item.authorId">
                          <img :src="item.headimg"
                               :alt="item.fullname">
                          <p class="name"> {{item.fullname}} </p>
                        </router-link>
                        <!-- <span>{{item.name}}</span> -->
                      </div>
                      <!-- 用户信息 end-->
                    </div>

                  </div>

                </li>
              </ul>
              <!-- 暂无 -->
              <ul class="classification_list _width"
                  v-if="!loading_bool && works_data.records.length==0">
                <div class="null_data">
                  <img src="@/assets/image/common/null_data.png"
                       alt="">
                  <p>暂无作品...</p>
                </div>
              </ul>
            </div>

            <div class="_width page_data card_body">
              <el-pagination background
                             :hide-on-single-page="true"
                             layout="prev, pager, next"
                             :current-page="page.current"
                             @current-change="handleCurrentChange"
                             :page-size="page.size"
                             :total="page.total"></el-pagination>
            </div>

          </div>
          <!-- 作品列表 end -->
        </div>

      </div>

    </div>

    <!-- 移动端  -->
    <div class="mobile_show user_mobile _width">
      <!-- 用户信息 -->
      <div class="_width _height user_mobile_conter">
        <div class="user_mobile_left">
          <a ref="javascript;;"
             class="hd_img">
            <img :src="details.headimg"
                 alt="">
          </a>
          <a href="javascript:;"
             class="name">{{details.fullname}}</a>
        </div>
        <!-- <div class="user_mobile_right">
          <button class="follow_button follow"
                  @click="insertFollow_data()"
                  v-if="details.isFollow ==0">+关注</button>
          <button class="follow_null follow"
                  @click="deleteFollow_data()"
                  v-if="details.isFollow ==1">已关注</button>
        </div> -->
      </div>
      <!-- 用户信息 end-->
    </div>
    <!-- 移动端简介 -->
    <div class="mobile_show _width text_conter">
      <p class="title">{{details.opusName}}</p>

      <div class="_width text_c">
        <p v-if="details.description !==''">
          {{details.description}}
        </p>

        <p v-if="details.description ==''">
          暂无...</p>
      </div>

      <!-- 简介 -->
      <!-- <div class="desc_zw _width">

        <div class="desc_conter">
          <input type="checkbox"
                 id="showMoreOrLess">
          <div class="desc_pp">
            <p class="content"
               v-if="details.description !==''">
              {{details.description}}
            </p>

            <p class="content"
               v-if="details.description ==''">
              暂无...</p>

          </div>
          <label for="showMoreOrLess"
                 class="show-more gd mobile_desc">
            <span class="sp2"><img src="@/assets/image/works/go_show.png"
                   alt=""></span>
          </label>
          <label for="showMoreOrLess"
                 class="show-less gd reg mobile_desc">
            <span class="sp2"><img src="@/assets/image/works/go_show.png"
                   alt=""></span>
          </label>
        </div>

      </div> -->
      <!-- 简介 end -->

    </div>

    <!-- 用户封面信息 -->
    <ul class="mobile_show _width mobile_cover_conter">
      <li v-for="(item,index) in details.picList"
          :key="index">
        <img :src="item.headimg|filterFun_as"
             alt=""
             class="_Width">
      </li>
    </ul>
    <!-- footer -->
    <Footer></Footer>
    <!-- footer end-->
  </div>
</template>

<script>
import work_swiper_type1 from '@/components/swiper/workSwiper_type1.vue'

import Header from '@/components/common/header.vue'
import Footer from '@/components/common/footer.vue'


import Loading from '@/components/loading/loading.vue'
import { WorkBy_details, playVote, related_works, insertFollow, deleteFollow } from '@/utils/api/activity.js'
import { socialShare } from "@/modules/common.js"
import { Info } from '@/utils/api/login.js'

export default {
  inject: ['reload'],

  data () {
    return {

      loading_bool: true,//加载loading
      details: [],//作品详情
      details_son: [],//详情的图片
      works_data: [],//相关作品
      details_son_one: [],//默认显示的图片信息
      page: {
        current: 1,
        size: 10,
        total: 0,//总数

      },
      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),

      photo_text: {},//每张照片的信息
      on_slick: 0,//照片的 信息

      // isFollowed: true,//投票
      active_cover: '',//点击后的图片
      active_index: 0,//index
      // isLogin: '',//是否登录


      share: {},  // 分享地址
      shareicon: 0, //分享iccon

      is_show: true,//展开收起
      height: "",//简介的动态 高度
      url: '',// 分享的地址  二维码地址

      myid: '',
      isLogin_user: {},
    }
  },
  created () {
    this.is_login();//是否登陆
    this.activityId = this.$route.query.activityId
    this.fullname = this.$route.query.fullname
    // this.headimg = this.$route.query.headimg
    this.type = this.$route.query.type
    this.workId = this.$route.query.workId
    this.authorId = this.$route.query.authorId


    this.isWebVote = this.$route.query.isWebVote
    this.isEndVote = this.$route.query.isEndVote

    this.router_url = this.$route.fullPath;//完整地址栏参数
    // console.log(this.router_url);
    this.myid = sessionStorage.getItem("id");
    let params = {
      activityId: this.activityId,
      fullname: this.fullname,
      // headimg: this.headimg,
      type: this.type,
      workId: this.workId,
      authorId: this.authorId,
      // isWebVote: this.isWebVote,
      // isEndVote: this.isEndVote
    }
    this.WorkBy_details_data(params)//详情数据
    window.scrollTo(0, 0);


    let params2 = {
      current: this.page.current,
      size: this.page.size,
      type: this.type,
      workId: this.workId,
    }
    this.related_works__data(params2);//相关作品
  },

  filters: {

    filterFun_as: function (value) {
      return value.replace('.jpg', '_activity_s.jpg').replace('.png', '_activity_s.png').replace('.jpeg', '_activity_s.jpeg').replace('.gif', '_activity_s.gif')//最大
    },
    filterFun_ss: function (value) {
      return value.replace('.jpg', '_ss.jpg')//最小
    },
    filterFun_sss: function (value) {
      return value.replace('.jpg', '_sss.jpg')//最小
    },
  },

  mounted () {
    // this.$nextTick(() => {
    //   this.showQRCodes();//生成二维码
    // })

  },
  computed: {},
  watch: {},
  methods: {
    // 点击头像
    on_ucenter (authorId) {
      // 如果是自己
      if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
        this.$router.push({ path: '/Pcenter?type=0' })
      } else {
        // 如果不是自己
        let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
        window.open(routeData.href, '_blank');
      }
    },


    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        }
      })
    },


    // 判断系统 下载
    openapp () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid) {
        // alert("我是安卓");
        window.open('https://appgallery.huawei.com/#/app/C10900136?sharePrepath=ag&locale=zh_CN&source=appshare&subsource=C10900136&shareTo=weixin&shareFrom=appmarket')
        // 
        this.android()
      }
      if (isIOS) {
        // alert("我是苹果");
        window.open('https://apps.apple.com/cn/app/%E4%B8%AD%E7%BB%8F%E8%A7%86%E8%A7%89/id1190222970')
      }
    },


    // 生成为二维码
    showQRCodes: function () {
      // setTimeout(() => {
      if (this.$refs.qrcodeContainers.innerHTML) {
        return false;
      }
      this.url = 'https://v.jingjiribao.cn/newcommunity/#' + this.router_url
      let qrcode = new this.$QRCode("qrcodes", {
        text: this.url, //当前地址栏完整参数
        width: 140,
        height: 140,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: this.$QRCode.CorrectLevel.H
      });
      // }, 1000);

    },

    // 点击导航  返回上一页
    tag () {
      this.$router.push({ path: '/activity_details/' + this.activityId })
      // let routeData = this.$router.resolve({ path: '/activity_details/' + this.activityId });
      // window.open(routeData.href, '_blank');
    },



    // 点击封面切换 拍照信息
    toClick (item) {
      this.photo_text = item
      this.on_slick = 1//隐藏默认显示的
    },

    // 详情数据
    WorkBy_details_data (params) {
      this.loading_bool = true;
      WorkBy_details(params).then((res) => {
        let data = res.data;
        this.details = data.data;
        this.details_son = data.data.picList;
        document.title = '中经视觉-' + this.details.opusName

        if (this.details_son) {
          this.details_son_one = data.data.picList[0].imageData;
        }

        this.loading_bool = false;
        this.getSocialShareUrls(); //分享详情
        this.showQRCodes();//生成二维码

      })
    },


    // 相关作品
    related_works__data (params) {
      this.loading_bool = true;
      related_works(params).then((res) => {
        let data = res.data;
        this.works_data = data.data;
        this.page.size = data.data.size;//每页数据
        this.page.total = data.data.total; //全部数据  
        this.page.current = data.data.current; //默认第一页
        this.loading_bool = false;
      })
    },

    // 点击分页
    handleCurrentChange (val) {
      let params2 = {
        current: val,
        size: this.page.size,
        type: this.type,
        workId: this.workId,
      }
      this.related_works__data(params2);//相关作品
      window.scrollTo(0, 850);

    },


    // 关注
    insertFollow_data () {
      if (this.isLogin == true) {
        let params_follow = {
          followId: this.authorId,
        }
        insertFollow(params_follow).then((res) => {
          let data = res.data;
          console.log(data);
          if (data.code == 200) {
            this.$notify({
              title: '关注成功',
              // message: '这是一条成功的提示消息',
              type: 'success'
            });

            this.details.isFollow = 1

            // let params = {
            //   activityId: this.activityId,
            //   fullname: this.fullname,
            //   // headimg: this.headimg,
            //   type: this.type,
            //   workId: this.workId,
            // }
            // this.WorkBy_details_data(params); //分享详情
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },


    // 取消关注
    deleteFollow_data () {
      if (this.isLogin == true) {
        let params_follow = {
          followId: this.authorId,
        }
        deleteFollow(params_follow).then((res) => {
          let data = res.data;
          console.log(data);
          if (data.code = 200) {
            this.$notify({
              title: '取消关注成功',
              // message: '这是一条成功的提示消息',
              type: 'success'
            });
            // let params = {
            //   activityId: this.activityId,
            //   fullname: this.fullname,
            //   // headimg: this.headimg,
            //   type: this.type,
            //   workId: this.workId,
            // }
            // this.WorkBy_details_data(params); //分享详情
            this.details.isFollow = 0
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

    // 点击投票 取消投票
    vote (workId, type) {
      this.is_login();
      if (this.isLogin == true) {
        let params_details = {
          activityId: this.activityId,
          workId: workId,
          type: type
        }
        this.playVote_data(params_details)
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

    //投票数据
    playVote_data (params_details) {
      playVote(params_details).then((res) => {
        this.loading_bool = true;
        let data = res.data;
        this.Publicity = data;
        if (data.code == 200) {

          this.$message({
            message: data.data,
            type: 'success'
          });
          // 成功后刷新详情
          let params = {
            activityId: this.activityId,
            fullname: this.fullname,
            // headimg: this.headimg,
            type: this.type,
            workId: this.workId,
          }
          this.WorkBy_details_data(params);//作品列表
          this.loading_bool = false

        } else {
          this.$message.error(data.message);
        }
      })
    },



    //  分享到qq
    share_qq () {
      const share = {
        title: this.details.opusName,
        desc: this.details.opusName,
        share_url: window.location.href,
      };
      window.open("https://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(share.share_url) + "&title=" + share.title + "&desc=" + share.desc);
    },
    //  分享到qq空间
    share_qz () {
      const share = {
        title: this.details.opusName,
        desc: this.details.opusName,
        share_url: window.location.href,
        // image_url: this.details_son.activityUrl,
      };
      window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(share.share_url) +
        '&site=掌上理工大&title=' + share.title +
        '&pics=' + share.image_url +
        '&summary=' + share.desc);
    },
    //  分享到微博
    share_wb () {
      const share = {
        title: this.details.opusName,
        desc: this.details.opusName,
        share_url: window.location.href,
        // image_url: this.details_son.activityUrl,
      };
      window.open('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');

    },

    // 分享
    getSocialShareUrls () {
      let info = {
        url: this.url,
        title: this.details.opusName,
        source: this.details.activityName,
        desc: this.details.opusName,
        // image: that.dataUrl,
        // summary: "报社内容"
      };
      ["qq", "wx", "wb", "kj"].forEach(v => {
        this.share[v] = socialShare(v, info);
      });
    },


    // 相关作品  进入详情
    // 进入作品详情
    on_details (activityId, fullname, type, workId, authorId) {

      if (type == 1) {
        this.reload()
        this.$router.push({
          path: '/workDeatils_type1',
          query: {
            activityId: activityId,
            fullname: fullname,
            // headimg: headimg,
            type: type,
            workId: workId,
            authorId: authorId,

            isWebVote: this.details_son.isWebVote,
            isEndVote: this.details_son.isEndVote,
          }
        })
      } else if (type == 2) {
        this.reload()
        this.$router.push({
          path: '/workDeatils_type2',
          query: {
            activityId: activityId,
            fullname: fullname,
            // headimg: headimg,
            type: type,
            workId: workId,
            authorId: authorId,

            isWebVote: this.isWebVote,
            isEndVote: this.isEndVote,
          }
        })
      }


    },

  },

  components: {
    Loading,
    socialShare,
    work_swiper_type1,
    Header, Footer
  },

}
</script>

<style scoped>
@import "../../assets/css/works/index.css";

/* 占位 */
.details_left_null {
  width: 100%;
  height: 6rem;
  position: relative;
  display: flex;
  justify-content: center;
  transition: all 0.3s;
}
.details_left_null .error_login_img {
  width: 0.5rem !important;
  height: 0.5rem !important;
}

.swiper-slide {
  width: 100%;
  height: 400px;
}
.scoped >>> .header_center .navList li:nth-child(7) a {
  color: #c00 !important;
}
.homeswiper {
  position: relative;
}
.dan_img {
  width: 100%;
  height: 5.6rem;
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/views/activity/workDeatils_type1.vue